import { render, staticRenderFns } from "./ActivixCrmLogo.vue?vue&type=template&id=7dd8b851&"
import script from "./ActivixCrmLogo.vue?vue&type=script&lang=js&"
export * from "./ActivixCrmLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports